import { Component, EventEmitter, Input, Output } from "@angular/core";
import * as _ from "lodash";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import "rxjs/add/observable/of";
// Observable operators
import "rxjs/add/operator/catch";
import "rxjs/add/operator/debounceTime";
import "rxjs/add/operator/distinctUntilChanged";
import "rxjs/add/operator/map";
import { Observable } from "rxjs/Observable";
import { Subject } from "rxjs/Subject";
import swal from "sweetalert2";
import { ServiceWalkInModel } from "../../../model/index";
import { CommonService, SubscribeService } from "../../../services/index";
import { AddServiceClientComponent } from "../serviceWalkIn/addServiceClient.component";

@Component({
  selector: "get-discount-approval",
  templateUrl: "./getBillDiscountApproval.component.html",
})
export class getBillDiscountApproval {
  @Input() query = "";
  @Input() bill_details;
  @Input() searching = false;
  ishideButton: boolean = false;
  isLoading: boolean = false;
  @Output() discountSelectEmit = new EventEmitter();
  @Output() discountRemoveEmit = new EventEmitter();
  @Output() saveServiceResponse = new EventEmitter();
  loadingIndicator: boolean = true;
  //@Output() search = new EventEmitter<string>();
  private searchTerms = new Subject<string>();
  searchVal = "";
  searchLoc = "";
  columns = [];
  isLoadMask: Promise<any>;
  filteredItems: Observable<ServiceWalkInModel[]>;

  gridList = [];
  searchTerm$ = new Subject<string>();
  disDetails = {
    discount: 0,
    description: "",
  };
  page = {
    limit: 50,
    count: 10,
    offset: 0,
    orderBy: "client_id",
    orderDir: "desc",
    query: "",
  };
  selectedDiscountIndex: number = 0;

  constructor(
    private commonService: CommonService,
    private modalService: BsModalService,
    public subscribeService: SubscribeService
  ) {}

  ngOnInit(): void {
    this.columns = [
      {
        name: "Client ID",
        prop: "client_no",
        width: 100,
        maxWidth: 120,
        toggle: true,
      },
      { name: "Name", prop: "client_name", maxWidth: 150 },
      { name: "D.O.B", prop: "disp_dob", maxWidth: 100 },
      { name: "Age", prop: "age", maxWidth: 60 },
      { name: "Address", prop: "address", maxWidth: 150 },
      { name: "Area", prop: "area", maxWidth: 150 },
      { name: "City", prop: "city", maxWidth: 100 },
      { name: "Mobile", prop: "mobile", maxWidth: 115 },
    ];

    //this.toggleCol = Object.assign({}, this.columns);
    this.billDiscountApprovalList();
  }

  billDiscountApprovalList() {
    let that = this,
      params = {
        ser_id: this.bill_details ? this.bill_details.ser_id : 0,
      };
    this.commonService.billDiscountApprovalList(params).then((results) => {
      that.gridList = results.data;
      that.page.count = results.totCnt;
    });
  }

  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.billDiscountApprovalList();
  }
  onChangePageSize(limit) {
    this.page.limit = limit;
    this.billDiscountApprovalList();
  }
  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }
  search(query: string) {
    this.searchTerms.next(query);
  }
  bsModalRef: BsModalRef;

  //ON CLICK NEW CLIENT BUTTON
  onclickNewClient(mode: string, row: any): void {
    let that = this;
    if (mode == "Add") {
      row = {
        mode: "Add",
      };
      this.bsModalRef = this.modalService.show(AddServiceClientComponent, {
        keyboard: false,
        ignoreBackdropClick: true,
        class: "modal-lg maxWidthPer-80",
      });
      this.bsModalRef.content.title = "Add New Service Client Details";
      this.bsModalRef.content.serviceClient = Object.assign({}, row);
      this.bsModalRef.content.resObj$.subscribe((res) => {
        that.saveServiceResponse.emit(res);
      });
    }
  }

  onSelectDiscount($event, row, ind) {
    if (row.status == "Pending" || row.status == "Rejected") {
      swal("Only approved discounts can be selected....");
    } else if (
      row.status == "Modified & Approved" ||
      row.status == "Approved"
    ) {
      this.gridList[this.selectedDiscountIndex].selected = "false";
      this.selectedDiscountIndex = ind;
      this.gridList[ind].selected = "true";
      $(".client-search-list a").removeClass("active");
      $event.currentTarget.classList.add("active");
      this.discountSelectEmit.emit(row);
    }
  }
  onRemoveDiscount($event, row, ind) {
    this.gridList[ind].selected = "false";
    $(".client-search-list a").removeClass("active");
    $event.currentTarget.classList.add("active");
    this.discountRemoveEmit.emit();
  }
  onDeleteDiscount(row) {
    let that = this;
    let data = {
      dis_id: row["dis_id"],
      mode: "Delete",
    };
    swal({
      title: "Are you sure to delete this discount amount?",
      showCancelButton: true,
      confirmButtonText: "Yes..Delete it!",
      cancelButtonText: "No.",
    }).then(
      function () {
        that.isLoadMask = that.commonService
          .saveUpdateDiscountApproval(data)
          .then(function (res: any) {
            that.loadingIndicator = false;
            if (res.success) {
              swal("SUCCESS", res.message, "success");
              that.subscribeService.subReloadServiceGrid();
              that.disDetails = {
                discount: 0,
                description: "",
              };
              that.billDiscountApprovalList();
            } else {
              swal("ERROR", res.message, "error");
            }
          })
          .catch(function (error: any) {
            that.isLoading = false;
            let res = JSON.parse(error._body);
            swal("ERROR", res.message, "error");
          });
      },
      function (dismiss) {}
    );
  }
  saveUpdateDiscountEntry() {
    let that = this;
    if (
      _.isEmpty(_.toString(that.disDetails.discount)) ||
      _.isEmpty(that.disDetails.description)
    ) {
      swal("WARNING", "Discount amount or description is Empty");
      return;
    }
    if (that.disDetails["discount"] <= 0) {
      swal("WARNING", "Invalid Discount Amount");
      return;
    }

    let data = {
      ser_id: that.bill_details["ser_id"],
      srf_no: that.bill_details["srf_no"],
      branch_id: that.bill_details["branch_id"],
      client_id: that.bill_details["client_id"],
      description: that.disDetails["description"],
      discount: that.disDetails["discount"],
      payment: that.bill_details["payment"],
      grand_total: that.bill_details["grand_total"],
      bill_type: that.bill_details["walk_in_type"],
      mode: "Add",
    };
    swal({
      title: "Are you sure to get approval for this amount?",
      showCancelButton: true,
      confirmButtonText: "Yes!",
      cancelButtonText: "No.",
    }).then(
      function () {
        that.isLoadMask = that.commonService
          .saveUpdateDiscountApproval(data)
          .then(function (res: any) {
            that.loadingIndicator = false;
            if (res.success) {
              swal("SUCCESS", res.message, "success");
              that.subscribeService.subReloadServiceGrid();
              that.disDetails = {
                discount: 0,
                description: "",
              };
              that.billDiscountApprovalList();
            } else {
              swal("ERROR", res.message, "error");
            }
          })
          .catch(function (error: any) {
            that.isLoading = false;
            let res = JSON.parse(error._body);
            swal("ERROR", res.message, "error");
          });
      },
      function (dismiss) {}
    );
  }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/getBillDiscountApproval/getBillDiscountApproval.component.ts